import React from 'react';

import './Chef.css';
import {  kevo, mercy, quote, sign, sign1, sign2 } from '../../constants/images';
import { SubHeading } from '../../components/SubHeading/SubHeading';

export const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={kevo} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="CEO's word" />
      <h1 className="headtext__cormorant">Travel the world</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={quote} alt="quote_image" />
          <p className="p__opensans">Every one deserves a day out</p>
        </div>
        <p className="p__opensans"> Tours and travels need to be as convinient as possible. At DGA, we provide the best services with convenience at the top of the list for the client. Welcome to the ride, keep away the seat belts, its a smooth ride. </p>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Muchemi</p>
        <p className="p__opensans">CEO & Founder</p>
        <img src={sign1} alt="sign_image" />
      </div>
    </div>
  </div>
);
export const Chef2 = () => (
  <div className="app__bg app__wrapper section__padding">
   
    <div className="app__wrapper_info">
      <SubHeading title="Director's word" />
      <h1 className="headtext__cormorant">With Passion, we deliver</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={quote} alt="quote_image" />
          <p className="p__opensans">Let us make your day, Literally.</p>
        </div>
        <p className="p__opensans">All we live for is to make the best out of a day, a holiday, a weekend, a vacation, and a month long tour. Everything needs to be hassle-free, while we carry your burdens of planning, ticketing, and assurance of a well planned and organized trip. </p>
      </div>

      <div className="app__chef-sign">
        <p>Mercy W</p>
        <p className="p__opensans">Director & Co-Founder</p>
        <img src={sign2} alt="sign_image" />
      </div>
    </div>
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={mercy} alt="chef_image" />
    </div>
  </div>
);

// export default Chef;
